import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import CustomDataTableSearch from "../../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { getJourneyStocks } from "../../../../../services/crm/salesJourney";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
const SearchJourneyStocks = ({ journeyID, onSelectStock }) => {
  const { reload } = useGlobalData();
  const [stocks, setStocks] = useState([]);
  useEffect(() => {
    getJourneyStocksData(journeyID);
  }, [journeyID, reload]);
  return (
    <CustomDataTableSearch
      data={stocks}
      onRefreshData={() => {
        getJourneyStocksData(journeyID);
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectStock(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectStock(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Journey Stock ID",
          field: "ID",
          body: null,
          sortable: true,
        },
        {
          header: "Warehouse Name",
          field: "warehouse.warehouseName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.warehouse.warehouseName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Item Type",
          field: "itemTypeName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
          hidden: true,
        },
        {
          header: "Item Code",
          field: "itemCode",
          body: (rowData) => (
            <React.Fragment>
              {rowData.itemType > 0 ? (
                <span>
                  <BootstrapTooltip title={rowData.itemTypeName}>
                    <span className="mr-2">
                      <i
                        className={
                          rowData.itemType === 1
                            ? "fas fa-boxes text-success"
                            : rowData.itemType === 2
                            ? "fas fa-tools text-primary"
                            : rowData.itemType === 3
                            ? "fas fa-building text-info"
                            : rowData.itemType === 4
                            ? "fas fa-boxes text-warning"
                            : rowData.itemType === 5
                            ? "fas fa-boxes text-danger"
                            : null
                        }
                      ></i>
                    </span>
                  </BootstrapTooltip>
                  <span>
                    <ResponsiveEllipsis
                      text={rowData.itemCode}
                      maxLine="1"
                      displayInline
                    />
                  </span>
                </span>
              ) : (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
                </React.Fragment>
              )}
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Item Name",
          field: "itemName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Status",
          field: "statusID",
          body: (rowData) => (
            <React.Fragment>
              <Badge
                variant={
                  rowData.statusID === 1
                    ? "info"
                    : rowData.statusID === 3
                    ? "success"
                    : rowData.statusID === 4
                    ? "warning"
                    : rowData.statusID === 5
                    ? "danger"
                    : rowData.statusID === 9
                    ? "danger"
                    : rowData.statusID === 10
                    ? "danger"
                    : null
                }
              >
                {rowData.statusID === 1
                  ? "Requested"
                  : rowData.statusID === 3
                  ? "Loaded"
                  : rowData.statusID === 4
                  ? "Partially Unloaded"
                  : rowData.statusID === 5
                  ? "Unloaded"
                  : rowData.statusID === 9
                  ? "Cancelled"
                  : rowData.statusID === 10
                  ? "Rejected"
                  : null}
              </Badge>
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Quantity",
          field: "qty",
          body: (rowData) => (
            <div>
              {rowData.qty} {rowData.uomName}
            </div>
          ),
          sortable: true,
        },
        {
          header: "Unit",
          field: "uomName",
          body: null,
          sortable: true,
          hidden: true,
        },
        {
          header: "Batch ID",
          field: "batchID",
          body: null,
          sortable: true,
        },
      ]}
    />
  );

  async function getJourneyStocksData(journeyID) {
    const response = await getJourneyStocks(journeyID, 3);
    const { data } = response.data;
    setStocks(data.journeyStocks);
  }
};

export default SearchJourneyStocks;
